import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-update-cycle-popup',
  standalone: true,
  imports: [MatDialogModule, MatIconModule],
  templateUrl: './update-cycle-popup.component.html',
  styleUrl: './update-cycle-popup.component.scss',
})
export class UpdateCyclePopupComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  ngOnInit(): void {
    console.log(this.data, 'data in popup');
    this.data = this.data.map((item: any) => {
      return { ...item, expanded: false };
    });
  }
  onExpandClick(no: number) {
    this.data[no].expanded = !this.data[no].expanded;
  }
}
